import React from "react";
import HomeHero from "./components/home/HomeHero";
import Marquee from "./components/home/Marquee";
import PillarsSection from "./components/home/PillarsSection";
import ParableSection from "./components/home/ParableSection";
import WarningDivider from "./components/home/WarningDivider";
import SignupSection from "./components/home/SignupSection";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative z-10">
      <HomeHero />
      <Marquee />
      <PillarsSection />
      <ParableSection />
      <WarningDivider />
      <SignupSection />
    </main>
  );
}
